// ============================================
// COSMIC HINDU - Store Layout
// ============================================

import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

export default function StoreLayout() {
  return (
    <div className="min-h-screen bg-temple-100 text-temple-cream relative">
      {/* Background ambient pattern */}
      <div className="fixed inset-0 bg-pattern pointer-events-none z-0" />

      <Header />
      <main className="relative z-[1]">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
